import Select, { type GroupBase, type StylesConfig } from "react-select";
import { appendClassName } from "utils";

import { OptionType, ResultsPerPageViewProps } from "./interface";
import { Wrapper } from "./style";

const setDefaultStyle: StylesConfig<
  OptionType,
  false,
  GroupBase<OptionType>
> = {
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    const getBackgroundColor = () => {
      if (isDisabled) {
        return undefined;
      }
      if (isSelected || isFocused) {
        return "white";
      }
      return undefined;
    };

    const getTextColor = () => {
      if (isDisabled) {
        return "#ccc";
      }
      return "#32323B";
    };

    const getActiveBackgroundColor = () => {
      return isDisabled ? undefined : "white";
    };

    return {
      ...styles,
      fontSize: "16px",
      backgroundColor: getBackgroundColor(),
      color: getTextColor(),
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor: getActiveBackgroundColor()
      }
    };
  },
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles) => ({ ...styles })
};

const wrapOption = (option: number) => ({
  label: option.toString(),
  value: option.toString()
});

const ResultsPerPageView = ({
  className,
  onChange,
  options,
  value: selectedValue,
  ...rest
}: ResultsPerPageViewProps) => {
  let selectedOption = null;

  if (selectedValue) {
    selectedOption = wrapOption(selectedValue);

    if (!options?.includes(selectedValue))
      options = [selectedValue, ...(options as number[])];
  }

  return (
    <Wrapper
      className={appendClassName("sui-results-per-page", className)}
      {...rest}
    >
      <label
        className="sui-results-per-page__label"
        id="results-per-page-label"
        htmlFor="results-per-page"
      >
        Viser
      </label>
      <Select
        className="sui-select sui-select--inline"
        id="results-per-page"
        aria-labelledby="results-per-page-label"
        classNamePrefix="sui-select"
        aria-label="Velg antall resultater per side"
        value={selectedOption}
        onChange={(o) => {
          if (o !== null) {
            onChange(Number.parseInt(o.value, 10)); // convert to number
          }
        }}
        options={options?.map((option) => wrapOption(option))}
        isSearchable={false}
        styles={setDefaultStyle}
      />
    </Wrapper>
  );
};

export default ResultsPerPageView;
